import React from 'react';
import "./Warenkorb.css";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import WarenkorbProdukt from './WarenkorbProdukt';
import { useHistory } from 'react-router-dom';

function Warenkorb() {

const history = useHistory();
 
    return (
        <div className="warenkorb">
            <div className="warenkorb_links">
            <div className="warenkorb_links_top_header">
            <KeyboardBackspaceIcon />
            <p onClick={() => history.push("/shop")}>Zurück zum Shop</p>
            </div>
            <hr />
            <div className="warenkorb_links_bottom_header">
            <h1>Warenkorb</h1>
            <p>Sie haben 3 Produkte in ihrem Warenkorb.</p>
            </div>
            <WarenkorbProdukt />
            </div>
            <div className="warenkorb_rechts">
            <div className="warenkorb_rechts_container">
                <div className="warenkorb_rechts_header">
                <p>Zahlungsart Auswählen</p>
                </div>
                <div className="warenkorb_rechts_zahlungsarten">
                <div className="warenkorb_rechts_zahlungsart">
                    <p>Zahlungsart</p>
                </div>
                <div className="warenkorb_rechts_zahlungsart">
                    <p>Zahlungsart</p>
                </div>
                <div className="warenkorb_rechts_zahlungsart">
                    <p>Zahlungsart</p>
                </div>
                <div className="warenkorb_rechts_zahlungsart">
                    <p>Zahlungsart</p>
                </div>
                </div>
                <div className="kontaktformular_payment">
          
            </div>
            </div>
            </div>
        </div>
    )
}

export default Warenkorb
